import SeoHead, { localBusinessJsonLd } from "@/components/SeoHead";
import CitiesGrid from "@/components/CitiesGrid";
import CtaBanner from "@/components/CtaBanner";
import QuoteForm from "@/components/QuoteForm";

export default function ZonesIndex() {
  return (
    <>
      <SeoHead
        title="Zones d'intervention en Seine-et-Marne (77) - Dégraissage Hotte Melun"
        description="20 villes desservies en Seine-et-Marne : Melun, Le Mée-sur-Seine, Dammarie-les-Lys, Fontainebleau, Montereau et plus. Intervention rapide 7j/7."
        canonicalPath="/zones"
        jsonLd={localBusinessJsonLd()}
      />
      <section className="relative bg-white">
        <div className="absolute inset-0 dh-radial-glow pointer-events-none" />
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-16 md:pt-24 pb-10">
          <div className="text-sm uppercase tracking-[0.25em] text-[#066ec4] font-bold mb-4">Zones d'intervention</div>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-black tracking-tight text-[#00367e] leading-[1.05]">
            20 villes en <span className="dh-underline">Seine-et-Marne</span>
          </h1>
          <p className="mt-6 max-w-3xl text-lg text-slate-700">
            Notre équipe locale couvre Melun et toute son agglomération, ainsi que les principales communes du 77 : Fontainebleau, Avon, Montereau, Nangis, et plus.
          </p>
        </div>
      </section>
      <CitiesGrid title="Toutes nos zones d'intervention" />
      <CtaBanner />
      <QuoteForm />
    </>
  );
}
